<ng-container *ngIf="data.loadMembersByPHI">
  <mat-dialog-content class="mat-typography update-profile-cart">
    <ng-container *ngTemplateOutlet="mailOrderLogo"></ng-container>

    <h3>{{ multilingualService.langMap?.LABEL_MAIL_ORDER_DIALOG_TITLE }}</h3>
    <ul>
      <li>
        {{ multilingualService.langMap?.LABEL_MAIL_ORDER_DIALOG_SUB_TITLE_1 }}
      </li>
      <li>
        {{ multilingualService.langMap?.LABEL_MAIL_ORDER_DIALOG_SUB_TITLE_2 }}
      </li>
    </ul>

    <ng-container *ngTemplateOutlet="memberRadioGroup"></ng-container>
  </mat-dialog-content>

  <mat-dialog-actions class="d-flex action-buttons">
    <button
      mat-raised-button
      [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
      class="primary-button uppercase"
      (click)="close('update-now')"
    >
      {{ multilingualService.langMap?.LABEL_MAIL_ORDER_DIALOG_UPDATE }}
    </button>

    <button
      mat-raised-button
      [attr.aria-label]="
        multilingualService?.langMap?.LABEL_MAIL_ORDER_DIALOG_SKIP
      "
      class="secondary-button uppercase"
      (click)="close('update-later')"
    >
      {{ multilingualService.langMap?.LABEL_MAIL_ORDER_DIALOG_SKIP }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="!data.loadMembersByPHI">
  <mat-dialog-content class="mat-typography update-profile-cart">
    <ng-container *ngTemplateOutlet="mailOrderLogo"></ng-container>

    <h3>
      {{ multilingualService.langMap?.LABEL_COMPLETE_PROFILE_DIALOG_TITLE }}
    </h3>
    <ul>
      <li style="list-style-type: none; margin-left: 0;">
        {{
          multilingualService.langMap?.LABEL_FAMILY_PROFILE_PMART_PROFILE_UPDATE
        }}
      </li>
    </ul>

    <div>
      <ng-container *ngTemplateOutlet="memberRadioGroup"></ng-container>
    </div>
  </mat-dialog-content> 

  <mat-dialog-actions class="d-flex action-buttons">
    <button
      mat-raised-button
      [attr.aria-label]="multilingualService?.langMap?.COMMON_LABEL_UPDATE"
      class="primary-button uppercase"
      (click)="close('update-now')"
    >
      {{ multilingualService.langMap?.LABEL_PRESCRIPTION_UPDATE_BUTTON }}
    </button>

    <button
      mat-raised-button
      [attr.aria-label]="multilingualService?.langMap?.COMMON_LABEL_CANCEL"
      class="secondary-button uppercase"
      (click)="close('update-later')"
    >
      {{ multilingualService.langMap?.COMMON_LABEL_CANCEL }}
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #mailOrderLogo>
  <div class="update-cart-img">
    <img src="assets/images/update-profile-cart.png" alt="Logo" width="100px" />
  </div>
</ng-template>

<ng-template #memberRadioGroup>
  <mat-radio-group
    [(ngModel)]="this.selectedMember"
    [attr.aria-label]="multilingualService?.langMap?.LABEL_SELECT_TEXT"
  >
    <ng-container *ngIf="membersDetails$ | async as members">
      <ng-container *ngFor="let member of members">
        <mat-radio-button [value]="member" class="selected-member">
          {{ member.memberProfile.firstName }}
          {{ member.memberProfile.lastName }}
        </mat-radio-button>
      </ng-container>
    </ng-container>
  </mat-radio-group>
</ng-template>
